import React, { FC, useState } from 'react';
import { Popup, NavBar, Button, Field, Form, Toast } from 'react-vant';
import { history } from '@umijs/max';
import ClosedEye from '@react-vant/icons/es/ClosedEye';
import EyeO from '@react-vant/icons/es/EyeO';
import './password.less';
import { validatePassword } from '@/utils/validate';
import { updatePwd, logout } from '@/service/login';

interface ModifyPasswordProps {
  isOpen: boolean;
  onClose: () => void;
}

const ModifyPassword: FC<ModifyPasswordProps> = ({ isOpen, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
 

  // 验证确认密码
  const validateConfirmPassword = (_: any, value: any) => {
    if (!value) {
      return Promise.reject('请确认密码');
    }

    if (value !== form.getFieldValue('password')) {
      return Promise.reject('两次输入的密码不一致');
    }

    return Promise.resolve();
  };

  const onFinish = (values: any) => {
    setLoading(true);
    const data = { ...values };
    data.openId = localStorage.getItem('userOpenId');
    updatePwd(data).then(async (res: any) => {
      if (res && res.code === 200) {
        Toast.success('修改成功，请重新登录！');
        const logRes = await logout();
        if (logRes && logRes.code === 200) {
          Toast.success({ message: '退出成功！' });
          localStorage.removeItem('token');
          localStorage.removeItem('userInfo');
          // localStorage.removeItem('wechatInfo');
          localStorage.removeItem('loginInfo');// 修改密码 重新登录
          history.push('/login');
        }
      }
    }).finally(() => {
      setLoading(false);
    })
  };
  return (
    <Popup
      visible={isOpen}
      onClose={onClose}
      position="bottom" // 可以设置为 'bottom' 或者其他位置，但为了全屏效果，我们通常使用自定义样式
      style={{
        width: '100%',
        height: '100%',
        background: 'white',
        position: 'fixed',
        top: 0,
        left: 0,
      }}
    >
      <div>
        <NavBar title="修改密码" onClickLeft={onClose}  />
        <div className="register-form">
          <Form
            form={form}
            onFinish={onFinish}
            initialValues={{
              phonenumber: '',
              oldPassword: '',
              password: '',
              confirmPassword: '',
            }}
          >
            <Form.Item
              name="phonenumber"
              label="手机号"
              rules={[{ required: true, message: '请输入手机号' }]}
            >
              <Field placeholder="请输入" clearable />
            </Form.Item>
            <Form.Item
              name="oldPassword"
              label="旧密码"
              rules={[{ validator: validatePassword }]}
            >
              <Field
                type={showOldPassword ? 'text' : 'password'}
                placeholder="请输入"
                rightIcon={showOldPassword ? <EyeO /> : <ClosedEye />}
                onClickRightIcon={() => setShowOldPassword(!showOldPassword)}
              />
            </Form.Item>
            <Form.Item
              name="password"
              label="新密码"
              rules={[{ validator: validatePassword }]}
            >
              <Field
                type={showPassword ? 'text' : 'password'}
                placeholder="请输入"
                rightIcon={showPassword ? <EyeO /> : <ClosedEye />}
                onClickRightIcon={() => setShowPassword(!showPassword)}
              />
            </Form.Item>

            <Form.Item
              name="confirmPassword"
              label="确认新密码"
              rules={[{ validator: validateConfirmPassword }]}
            >
              <Field
                type={showConfirmPassword ? 'text' : 'password'}
                placeholder="请再次输入"
                rightIcon={showPassword ? <EyeO /> : <ClosedEye />}
                onClickRightIcon={() =>
                  setShowConfirmPassword(!showConfirmPassword)
                }
              />
            </Form.Item>

            <div className="submit-btn">
              <Button
                round
                block
                type="primary"
                nativeType="submit"
                loading={loading}
                loadingText="提交中..."
              >
                提交
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </Popup>
  );
};
export default ModifyPassword;
